import type { ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface HeaderProps {
  children?: ReactNode;
  sticky?: boolean;
}

export const Header = ({ sticky, children }: HeaderProps) => (
  <div
    className={classNames("main__header", { "main__header--sticky": sticky })}
  >
    {children}
  </div>
);
